import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearUserInfo } from "../reducers/userSlice";
import { AppDispatch } from "../store";

const CHECK_INTERVAL = 60000; 

export const useSessionExpiry = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    sessionStorage.clear();
    dispatch(clearUserInfo());
    navigate("/login?sessionExpired=true");
  }, [dispatch, navigate]);

  useEffect(() => {
    const checkExpiry = () => {
      const expiryTime = sessionStorage.getItem("tokenExpiry");
      if (expiryTime && Date.now() > Number(expiryTime)) {
        handleLogout();
      }
    };

    // Check immediately on mount
    checkExpiry();

    // Set up interval to check periodically
    const intervalId = setInterval(checkExpiry, CHECK_INTERVAL);

    // Also check when window regains focus
    const handleFocus = () => checkExpiry();
    window.addEventListener("focus", handleFocus);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", handleFocus);
    };
  }, [handleLogout]);
};
